<template>
  <div v-if="sortedAgendaDataWithSerialNumbers.length > 0">
    <div class="table-header-div">
      <div class="agenda-icon-div">
        <AgendaIcon />
      </div>
      <div class="agenda-heading-div">
        <h3 class="agenda-heading">Agenda</h3>
      </div>
      <div class="number-of-records-div"><span class="number-of-records-span">{{
        agendaDataLength
      }}</span></div>
    </div>

    <DataTable :value="sortedAgendaDataWithSerialNumbers" paginator rows="7" tableStyle="min-width: 10rem"
      @row-click="onSelectPatient">
      <Column field="serialNumber" header="" sortable style="width: 10%" header-class="header-style-class"
        body-class="body-style-class"></Column>

      <Column field="given" header="PATIENT NAME" sortable style="width: 25%" header-class="header-style-class"
        body-class="body-style-class"></Column>
      <Column field="caregiver_name" header="REQUESTING PHYSICIAN" sortable style="width: 25%"
        header-class="header-style-class" body-class="body-style-class"></Column>
    </DataTable>
  </div>
  <div>
    <Attendance />
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import Attendance from './Attendance.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import AgendaIcon from '../../icons/AgendaIcon.vue'

const store = useStore()
const sortedAgendaDataWithSerialNumbers = ref([])
const agendaDataLength = ref([])
const selectedMeeting = computed(() => store.state.session.meeting)
const upcomingMeetings = computed(() => store.state.session.upcomingMeetings)
const agendaData = computed(() => {
  const agendaList = selectedMeeting.value && upcomingMeetings.value && upcomingMeetings.value.filter((meeting) => meeting[0].calendar_id == selectedMeeting.value.data.calendar_id)
  return agendaList && agendaList.flat() || []
})

watch(agendaData, (newAgendaData) => {
  if (newAgendaData) {
    sortedAgendaDataWithSerialNumbers.value = newAgendaData.map((item, index) => {
      return { ...item, serialNumber: index + 1 }
    })
  }
  agendaDataLength.value = sortedAgendaDataWithSerialNumbers.value?.length || 0
})

const onSelectPatient = (event) => {
  const rowData = event.data
  const isAgendaPatientClicked = true
  store.dispatch('setSessionPatientFromAgenda', { rowData, publish: true })
  store.dispatch('setAgendaPatientClicked', { isAgendaPatientClicked, publish: true })

}
</script>

<style lang="scss" scoped>
.table-header-div {
  display: flex;
  background-color: #ffffff;
}

.agenda-icon-div {
  width: 15%;
  margin-top: 4.5%;
}

.agenda-heading-div {
  width: 65%;
  text-align: initial;
}

.agenda-heading {
  margin-left: 16px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8%;
}

.number-of-records-div {
  width: 20%;
  margin-top: 4%;
}
</style>
